import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Logo from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

const HERO = "https://images.unsplash.com/photo-1714912213756-821842ebe76a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxjaGlsZHJlbiUyMG5hdHVyZSUyMHdpbGRlcm5lc3MlMjBmb3Jlc3QlMjBleHBsb3JhdGlvbiUyMHNjaWVuY2V8ZW58MHx8fHwxNzkwMzI0NjEwfDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      navigate(["admin", "super_admin"].includes(u.role) ? "/admin" : "/dashboard");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="flex flex-col justify-center px-6 py-12 lg:px-20">
        <Logo />
        <div className="mx-auto mt-12 w-full max-w-sm">
          <h1 className="font-display text-3xl font-bold text-navy">Welcome back</h1>
          <p className="mt-2 text-slateBrand">Log in to your family account.</p>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <Label htmlFor="email" className="font-display font-semibold text-navy">Email</Label>
              <Input id="email" data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12" placeholder="you@example.com" />
            </div>
            <div>
              <Label htmlFor="password" className="font-display font-semibold text-navy">Password</Label>
              <Input id="password" data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12" placeholder="••••••••" />
            </div>
            <Button data-testid="login-submit" disabled={loading} className="h-12 w-full bg-brandblue font-display text-base font-semibold hover:bg-blue-700">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Log In"}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-slateBrand">New to H.E.A.? <Link to="/register" className="font-semibold text-brandblue">Create an account</Link></p>
        </div>
      </div>
      <div className="relative hidden lg:block">
        <img src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="absolute bottom-12 left-12 right-12">
          <p className="font-display text-2xl font-bold text-white">The World Is Their Classroom.</p>
        </div>
      </div>
    </div>
  );
}
